import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';

export default function PrivacyPolicyDialog(props) {

    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{ background: '#000', color: '#FFF' }}>
                    {'Privacy Notice'}
                    <IconButton
                        aria-label="close"
                        onClick={props.onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: '#FFF'
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className='privacy-alert-description'>
                        <Typography>
                            Honeywell International Inc. and its affiliates (<b>“Honeywell”</b>, <b>“we”</b> or <b>“our”) </b>
                            may collect, use, and share information, including personal information, from
                            our customer (your employer) and end users in connection with the Enacto
                            software offering (<b>“Offering”</b>). We will collect personal information when
                            you register for this Offering and provide your contact details with us.
                            This information includes, but not limited to, your name, email, title,
                            login credentials, site location, and the company for which you work. We
                            will use the information for (i) facilitating communication with you about
                            the Offering; (ii) the provision and deployment of the Offering and
                            related services, consultancy, data migration, installation of systems,
                            provision of support and maintenance services, training, channel and/or
                            supplier administration and support; (iii) managing product and service
                            development, improving existing and developing new products and services,
                            research and development, providing insights into company assets,
                            strategic planning, providing business intelligence, project management;
                            and (iv) any other scope and purpose as described in our agreement
                            with our customer. For more information on how we use your personal
                            information including how to exercise your data subject rights please
                            refer to the  <a href='https://www.honeywell.com/us/en/privacy-statement' target='_blank'>
                                Honeywell Privacy Statement</a>.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}